<template>
  <div v-if="hasPermission()">
    <el-menu-item v-if="!hasChildren()" :index="item.path">
      <i v-if="isElIcon()" :class="item.meta.icon" />
      <!-- <svg-icon v-else :icon-class="item.meta.icon" /> -->

      <span slot="title">{{ item.meta.title }}</span>
    </el-menu-item>
    <el-submenu v-else :index="item.path">
      <template slot="title">
        <i v-if="isElIcon()" :class="item.meta.icon" />
        <!-- <svg-icon v-else :icon-class="item.meta.icon" /> -->

        <span slot="title">{{ item.meta.title }}</span>
      </template>
      <MenuItem
        v-for="child in item.children"
        :key="child.path"
        :item="child"
      />
    </el-submenu>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "MenuItem",
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
  computed: {
    ...mapGetters(["permission", "roles", "username", "designatedSuperAdmin"]),
  },
  methods: {
    hasPermission() {
      if (!this.hasRestrictedAccount()) {
        return false;
      }
      if (this.item.meta && this.item.meta.superAdmin) {
        return this.isSuperAdmin();
      }
      // console.debug(this.permission,'this.permission')
      if (this.permission.indexOf(this.item.path) != -1) {
        return true;
      }
      return false;
    },
    // 菜单控制只是用户体验；对应后端接口仍有同样的指定账号与超级管理员校验。
    isSuperAdmin() {
      const account = (this.username || "").toLowerCase();
      return (
        account === "admin" ||
        (this.roles || []).some(
          (role) => (role.code || "").toLowerCase() === "admin"
        )
      );
    },
    hasRestrictedAccount() {
      const requiredAccount =
        this.item.meta && this.item.meta.restrictedAccount;
      if (!requiredAccount) {
        return true;
      }
      // 短信登录会把会话 account 替换为手机号，不能在浏览器端自行比较账号文本。
      return this.designatedSuperAdmin === true;
    },
    hasChildren() {
      // console.debug(this.item.children,this.item.children)
      if (this.item.children) {
        return true;
      }
      return false;
    },
    isElIcon() {
      if (this.item.meta.icon.includes("el-icon")) {
        return true;
      }
      return false;
    },
  },
};
</script>
